import DeliveryService from "../DeliveryService"


const Team = {
    formData(data) {
        let form = new FormData()
        for (let obj in data) {
            form.append(obj, data[obj])
        }
        return form
    },
    list(params) {
        var queryString = Object.keys(params)
            .map(key => key + "=" + params[key])
            .join("&");
        return DeliveryService.get(`/console/team?` + queryString)
    },
    add(data) {
        return DeliveryService.post(`/console/team`, data)
    },

}

export default Team